import { THEME } from '@lyon/utils/theme';
import { BlockOverrides } from 'baseui/block';

export const CONTAINER: BlockOverrides = {
  Block: {
    style: {
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: '4vh',
      display: 'grid',
      gridTemplateColumns: '1fr',

      [THEME.media.large]: {
        paddingLeft: '6vw',
        paddingRight: '6vw',
        paddingTop: '6vh',
        gridTemplateColumns: '32vw 1fr',
      },

      [THEME.media.xlarge]: {
        paddingLeft: '10vw',
        paddingRight: '10vw',
        gridTemplateColumns: '18vw 1fr',
      },
    },
  },
};

export const CONTENT: BlockOverrides = {
  Block: {
    style: {
      paddingLeft: '4vw',
      paddingRight: '4vw',
    },
  },
};

export const FOOTER: BlockOverrides = {
  Block: {
    style: {
      marginLeft: '24px',
      marginRight: '24px',

      [THEME.media.large]: {
        marginLeft: '6vw',
        marginRight: '6vw',
      },

      [THEME.media.xlarge]: {
        marginLeft: '12vw',
        marginRight: '12vw',
      },
    },
  },
};
